var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 733,
    viewBox: "0 0 394 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.833 420.5C492.833 714.361 276.096 952.5 8.83337 952.5C-258.429 952.5 -475.167 714.361 -475.167 420.5C-475.167 126.639 -258.429 -111.5 8.83337 -111.5C276.096 -111.5 492.833 126.639 492.833 420.5Z",
    fill: "url(#paint0_linear_1_46)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_1_46)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M807.833 538C807.833 869.725 578.755 1138.5 296.333 1138.5C13.9119 1138.5 -215.167 869.725 -215.167 538C-215.167 206.275 13.9119 -62.5 296.333 -62.5C578.755 -62.5 807.833 206.275 807.833 538Z",
    fill: "url(#paint2_linear_1_46)",
    fillOpacity: 0.3,
    stroke: "url(#paint3_radial_1_46)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_46",
    x1: 8.83337,
    y1: -112,
    x2: 8.83337,
    y2: 953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_46",
    x1: 516.298,
    y1: 367.558,
    x2: -615.289,
    y2: 595.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCC0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_46",
    x1: 296.333,
    y1: -63,
    x2: 296.333,
    y2: 1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB69FF",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_46",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.333 538) rotate(89.9728) scale(1245.08 1060.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#D8B9FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9BAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingbg);
export default __webpack_public_path__ + "static/media/pricingbg.8b2f1cb5b1d03972043db92539c77081.svg";
export { ForwardRef as ReactComponent };